import styled from "styled-components";
import { JoinSubmitWrap } from "../RopForm/JoinSubmit";

export const Rop01JoinSubmitWrap = styled(JoinSubmitWrap)`
  margin: 10px auto;
`